import { render } from "./CollectionDetails.vue?vue&type=template&id=10272514&scoped=true"
import script from "./CollectionDetails.vue?vue&type=script&lang=js"
export * from "./CollectionDetails.vue?vue&type=script&lang=js"

import "./CollectionDetails.vue?vue&type=style&index=0&id=10272514&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10272514"]])

export default __exports__